<template>
  <section class="standard-box-edit modal-backdrop">
    <div
      class="modal-container standard-size"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">EDIT BOX</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="1.5"></v-icon>
        </div>
      </div>

      <!-- Language Container -->
      <language-adaptive-select
        v-if="!$isSingleLanguage"
        @change="toggleLanguage"
        :languageTypes="languageTypes"
        :localLanguageTypesIndex="localLanguageTypesIndex"
      />

      <div
        class="modal-container__content"
        v-for="(languageType, key) in languageTypes"
        :key="key"
        v-show="localLanguageTypesIndex === languageType.index"
      >
        <!-- Box Content -->
        <div class="input-group">
          <h3 class="h2">Box Content</h3>

          <GlobalInputTextfield
            label="Title"
            :inputId="'title' + key"
            v-model="selectedBoxInfo.titles[localLanguageTypesIndex]"
            maxlength="30"
          />
          <GlobalInputTextfield
            label="Text"
            :inputId="'text' + key"
            v-model="selectedBoxInfo.texts[localLanguageTypesIndex]"
            maxlength="30"
          />
          <GlobalInputTextfield
            label="Text Two"
            :inputId="'textTwo' + key"
            v-model="selectedBoxInfo.textsTwo[localLanguageTypesIndex]"
            maxlength="30"
          />

          <div class="icon-image-container">
            <div class="icon-image-container__radio-container">
              <button
                v-if="showSelection === 'BGIMAGE'"
                class="button-neutral"
                @click="showImageModal = true"
              >
                Choose BG Image
              </button>
              <button
                v-if="showSelection === 'IMAGE'"
                class="button-neutral"
                @click="showImageModal = true"
              >
                Choose Image
              </button>
              <button
                v-if="showSelection === 'ICON'"
                class="button-neutral"
                @click="handleShowIconModal"
              >
                Choose Icon
              </button>
              <ImageManager
                v-if="showImageModal"
                :isModal="true"
                @changed="onSelectedImage"
                @close="showImageModal = false"
              />
              <!-- <div class="modal-backdrop" style="background-color: unset; overflow: hidden" v-if="showIconModal" @click="handleShowIconModal"> </div> -->
              <label class="input-radio"
                >Icon
                <input type="radio" value="ICON" v-model="showSelection" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Image
                <input type="radio" value="IMAGE" v-model="showSelection" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Background Image
                <input type="radio" value="BGIMAGE" v-model="showSelection" />
                <span class="radio-button"></span>
              </label>
              <IconPicker
                v-if="showIconModal"
                :isModal="true"
                @selectedNewIcon="selectedNewIcon"
                @close="handleShowIconModal"
              />
            </div>
            <div
              v-if="showSelection === 'ICON'"
              class="icon-image-container__icon"
              style="cursor: pointer"
              @click="handleShowIconModal"
            >
              <!-- <GlobalInputDropdown label="Select Icon" :inputId="'selectIcon' + key" v-model="selectedIcon" :options="newIconsArray"/> -->
              <div class="icon">
                <v-icon :name="selectedIcon" v scale="5"></v-icon>
              </div>
            </div>
            <div
              v-else-if="showSelection === 'IMAGE'"
              class="icon-image-container__image"
            >
              <img :src="selectedBoxInfo.iconImage || ''" />
            </div>
            <div
              v-else-if="showSelection === 'BGIMAGE'"
              class="icon-image-container__image"
            >
              <img :src="selectedBoxInfo.backgroundImage || ''" />
            </div>
          </div>
        </div>

        <!-- Colors -->
        <div class="input-group">
          <h3 class="h2 colorPickerWrapper">
            Colors
            <div
              v-if="showTextColorPicker"
              class="colorOuterWrap"
              :class="{ changedPickerPosition: changedPickerPosition }"
            >
              <div class="colorInnerWrap">
                <div class="color-button-wrapper">
                  <chrome-picker v-model="colors[activeColorPicker]" />
                  <button
                    class="color-picker-button"
                    v-on:click="closeColorPicker()"
                  >
                    Select
                  </button>
                  <button
                    class="closeBtn color-picker-button"
                    v-on:click="closeColorPicker()"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </h3>

          <div
            class="color-input-wrapper"
            v-if="showSelection === 'ICON'"
            @click="showColorPicker('iconColor')"
          >
            <GlobalInputTextfield
              label="icon color"
              :inputId="'iconColor' + key"
              v-model="selectedBoxInfo.iconColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: selectedBoxInfo.iconColor }"
            ></div>
          </div>
          <div
            class="color-input-wrapper"
            v-if="showSelection !== 'BGIMAGE'"
            @click="showColorPicker('boxColor')"
          >
            <GlobalInputTextfield
              label="box color"
              :inputId="'boxColor' + key"
              v-model="selectedBoxInfo.boxColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: selectedBoxInfo.boxColor }"
            ></div>
          </div>
          <div
            class="range-input-wrapper"
            v-if="showSelection === 'BGIMAGE'"
          >
            <GlobalInputRangefield
              label="background transparency"
              :inputId="'bgTransparency' + key"
              v-model="selectedBoxInfo.bgTransparency"
              minamount="0"
              maxamount="100"
            />
          </div>
          <div class="color-input-wrapper" @click="showColorPicker('boxText')">
            <GlobalInputTextfield
              label="text color"
              :inputId="'textColor' + key"
              v-model="selectedBoxInfo.boxText"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: selectedBoxInfo.boxText }"
            ></div>
          </div>

          <div class="counterWrap">
            <div
              v-on:click="showColorPicker('btntext')"
              v-bind:style="{ backgroundColor: selectedBoxInfo.btntext }"
              class="colorSquare"
            ></div>
          </div>
        </div>

        <!-- Button -->
        <div class="input-group">
          <h3 class="h2">Button</h3>
          <GlobalInputSwitch
            label="Include Button?"
            v-model="showButton"
          />
          <div v-if="showButton === true">
            <GlobalInputTextfield
              label="Button Text"
              :inputId="'button' + key"
              v-model="selectedBoxInfo.buttonTitles[localLanguageTypesIndex]"
              maxlength="30"
            />
            <div
              class="color-input-wrapper"
              @click="showColorPicker('btncolor')"
            >
              <GlobalInputTextfield
                label="Button Color"
                :inputId="'btncolor' + key"
                v-model="selectedBoxInfo.btncolor"
                maxlength="7"
              />
              <div
                class="color-indicator"
                :style="{ backgroundColor: selectedBoxInfo.btncolor }"
              ></div>
            </div>
            <div
              class="color-input-wrapper"
              @click="showColorPicker('btntext')"
            >
              <GlobalInputTextfield
                label="Button Text Color"
                :inputId="'btntext' + key"
                v-model="selectedBoxInfo.btntext"
                maxlength="7"
              />
              <div
                class="color-indicator"
                :style="{ backgroundColor: selectedBoxInfo.btntext }"
              ></div>
            </div>

            <h4 class="input-label-lookalike">
              What should the button link to?
            </h4>
            <div class="horizontal-radio">
              <label class="input-radio"
                >PDF File
                <input type="radio" value="pdf" v-model="mediaType" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Page
                <input type="radio" value="page" v-model="mediaType" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Website
                <input type="radio" value="website" v-model="mediaType" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Phone
                <input type="radio" value="phoneNumber" v-model="mediaType" />
                <span class="radio-button"></span>
              </label>
              <label class="input-radio"
                >Email
                <input type="radio" value="email" v-model="mediaType" />
                <span class="radio-button"></span>
              </label>
            </div>

            <div v-show="mediaType === 'pdf'">
              <div v-if="pdfArray.length == 0">
                <p>No PDF files found</p>
              </div>
              <div v-else>
                <GlobalInputDropdown
                  label="PDF File"
                  :inputId="'pdfFile' + key"
                  v-model="selectedFileUrl"
                  :options="pdfArray"
                />
              </div>
            </div>

            <div v-show="mediaType === 'page'">
              <GlobalInputDropdown
                v-model="selectedPage"
                label="Page"
                :inputId="'page' + key"
                :options="pagesArray"
              />
            </div>

            <div v-show="mediaType === 'website'">
              <GlobalInputTextfield
                label="Website"
                :inputId="'website' + key"
                v-model="httpLinks[localLanguageTypesIndex]"
              />
            </div>

            <div v-show="mediaType === 'phoneNumber'">
              <GlobalInputTextfield
                label="Phone"
                :inputId="'phoneNumber' + key"
                v-model="mobilePhoneNumber"
              />
            </div>

            <div v-show="mediaType === 'email'">
              <GlobalInputTextfield
                label="Email"
                :inputId="'email' + key"
                v-model="emailAddress"
              />
            </div>
          </div>
        </div>

        <!-- Button Container -->
        <div class="button-container">
          <button class="button-neutral" @click="btnCancel()">Cancel</button>
          <button
            class="button-positive"
            @click="btnUpdate()"
            :disabled="provideLinkError && showButton"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "@/firebase";
import { Sketch } from "vue-color";
import ImageManager from "@/components/MediaPage/MediaImages";
import GlobalInputTextfield from "@/components/GlobalComponents/GlobalInputTextfield";
import GlobalInputRangefield from "@/components/GlobalComponents/GlobalInputRangefield";
import GlobalInputDropdown from "@/components/GlobalComponents/GlobalInputDropdown";
import GlobalInputSwitch from "@/components/GlobalComponents/GlobalInputSwitch";
import IconPicker from "@/components/GlobalComponents/IconPicker.vue";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
import LanguageAdaptiveSelect from '@/components/Ui/LanguageAdaptiveSelect';

export default {
  components: {
    "chrome-picker": Sketch,
    ImageManager,
    GlobalInputTextfield,
    GlobalInputRangefield,
    GlobalInputDropdown,
    GlobalInputSwitch,
    IconPicker,
    LanguageAdaptiveSelect
  },
  mixins: [newLanguageTypesFormatMixin],
  props: {
    box: Object,
    completeBoxArray: Array,
    pagesObject: Object,
    selectedBoxIndex: Number,
  },
  data() {
    return {
      selectedBoxInfo: Object.assign({}, JSON.parse(JSON.stringify(this.box))),
      colors: {
        boxText: {
          hex: "#194d33",
        },
        iconColor: {
          hex: "#194d33",
        },
        boxColor: {
          hex: "#194d33",
        },
        btntext: {
          hex: "#194d33",
        },
        btncolor: {
          hex: "#194d33",
        },
      },
      showTextColorPicker: false,
      activeColorPicker: "",
      showSelection: "",
      selectedPage: "Select",
      showButton: null,
      showImageModal: false,
      showIconModal: false,
      selectedIcon: "hotel",
      options: [],
      mediaType: "",
      mobilePhoneNumber: "",
      emailAddress: "",
      httpLinks: this.box.httpLinks || [],
      selectedFileUrl: "None",
      localLanguageTypesIndex: 0,
      languageTypes: [],
      pdfArray: [],
      pagesArray: [],
      newIconsArray: [
        { text: "bed", value: "bed" },
        { text: "regular/map", value: "regular/map" },
        { text: "wifi", value: "wifi" },
        { text: "hotel", value: "hotel" },
        { text: "utensils", value: "utensils" },
        { text: "bicycle", value: "bicycle" },
        { text: "car", value: "car" },
        { text: "heart", value: "heart" },
        { text: "train", value: "train" },
        { text: "shopping-bag", value: "shopping-bag" },
        { text: "map-marker", value: "map-marker" },
        { text: "street-view", value: "street-view" },
        { text: "map-pin", value: "map-pin" },
        { text: "info", value: "info" },
        { text: "suitcase", value: "suitcase" },
        { text: "book", value: "book" },
        { text: "music", value: "music" },
        { text: "map-signs", value: "map-signs" },
        { text: "check-circle", value: "check-circle" },
        { text: "star", value: "star" },
        { text: "shopping-basket", value: "shopping-basket" },
        { text: "tree", value: "tree" },
        { text: "binoculars", value: "binoculars" },
        { text: "hourglass", value: "hourglass" },
        { text: "heartbeat", value: "heartbeat" },
        { text: "calendar", value: "calendar" },
        { text: "check", value: "check" },
        { text: "users", value: "users" },
        { text: "bell", value: "bell" },

        { text: "brands/tripadvisor", value: "brands/tripadvisor" },
        { text: "brands/instagram", value: "brands/instagram" },
        { text: "brands/facebook-f", value: "brands/facebook-f" },
        { text: "brands/linkedin-in", value: "brands/linkedin-in" },
        { text: "brands/facebook", value: "brands/facebook" },
        { text: "regular/heart", value: "regular/heart" },
        { text: "regular/thumbs-up", value: "regular/thumbs-up" },
        { text: "regular/sun", value: "regular/sun" },
        { text: "brands/facebook-square", value: "brands/facebook-square" },
        { text: "brands/youtube", value: "brands/youtube" },
        { text: "glass-martini", value: "glass-martini" },
        { text: "regular/newspaper", value: "regular/newspaper" },
        { text: "brands/gratipay", value: "brands/gratipay" },
        { text: "regular/smile", value: "regular/smile" },
      ],
    };
  },
  firebase() {
    return {
      filesObject: {
        source: db.ref(`files/${this.$customerId}/${this.$hotelId}`),
        readyCallback: (data) => {
          // If there are no pdfs, just create empty object
          const files = data.val() || new Object();

          // Convert object of object to array of objects for forEach
          Object.values(files).forEach((file) => {
            let pdfObject = {};
            pdfObject.text = file.fileName;
            pdfObject.value = file.url;

            this.pdfArray.push(pdfObject);
          });
        },
      },
    };
  },
  watch: {
    colors: {
      handler() {
        this.selectedBoxInfo[this.activeColorPicker] = this.colors[
          this.activeColorPicker
        ].hex;
      },
      deep: true,
    },
    selectedPage: function () {
      // Due to dropdown being a component, we can only bind one value.
      // Luckily, we can find the index again :thumbs-up:
      const selectedPageIndex = this.pagesArray.findIndex(
        (object) => object.value === this.selectedPage
      );
      const selectedPageName = this.pagesArray[selectedPageIndex]
        ? this.pagesArray[selectedPageIndex].text
        : "Nothing selected";

      const selectedPageValue = this.pagesArray[selectedPageIndex]
        ? this.pagesArray[selectedPageIndex].value
        : "Nothing selected";

      this.selectedBoxInfo.pageName = selectedPageName;
      this.selectedBoxInfo.page = selectedPageValue;
    },
    mobilePhoneNumber: function () {
      this.selectedBoxInfo.pageName = "mobilePhone";
      this.selectedBoxInfo.page = this.mobilePhoneNumber;
    },
    emailAddress: function () {
      this.selectedBoxInfo.pageName = "emailAddress";
      this.selectedBoxInfo.page = this.emailAddress;
    },
    httpLinks: {
      handler() {
        const currentHttpLink = this.httpLinks[this.localLanguageTypesIndex];
        this.selectedBoxInfo.httpLinks = this.httpLinks;
        this.selectedBoxInfo.pageName = 'Costum-link';
        this.selectedBoxInfo.page = currentHttpLink;
      },
      deep: true
    },
    selectedFileUrl: function () {
      this.selectedBoxInfo.page = this.selectedFileUrl;
      this.selectedBoxInfo.pageName = "file";
    },
    selectedIcon: function () {
      this.selectedBoxInfo.icon = this.selectedIcon ? this.selectedIcon : "";
    },
    showSelection: function () {
      if (this.showSelection === "ICON") {
        this.selectedBoxInfo.showIcon = true;
        this.selectedBoxInfo.showIconImage = false;
        this.selectedBoxInfo.showBgImage = false;
      } else if(this.showSelection === "IMAGE") {
        this.selectedBoxInfo.showIcon = false;
        this.selectedBoxInfo.showIconImage = true;
        this.selectedBoxInfo.showBgImage = false;
      } else {
        this.selectedBoxInfo.showIcon = false;
        this.selectedBoxInfo.showIconImage = false;
        this.selectedBoxInfo.showBgImage = true;
      }
    },
    showButton: function () {
      if (this.showButton === false) {
        this.selectedBoxInfo.showButton = false;
      } else {
        this.selectedBoxInfo.showButton = true;
      }
    },
  },
  async created() {
    
    this.localLanguageTypesIndex = await this._getLanguageIndex();
    this.languageTypes = await this._getCorrectEventLanguages();

    this.showButton = this.selectedBoxInfo.showButton;

    // IF BOX COLOR DOESN'T EXIST, SET IT TO WHITE
    if (!this.selectedBoxInfo.boxColor) {
      this.selectedBoxInfo.boxColor = "#FFFFFF";
    }

    // IF BOX TEXT COLOR DOESN'T EXIST, SET IT TO BLACK
    if (!this.selectedBoxInfo.boxText) {
      this.selectedBoxInfo.boxText = "#000000";
    }

    // IF BUTTON COLOR DOESN'T EXIST, SET IT TO WHITE
    if (!this.selectedBoxInfo.btncolor) {
      this.selectedBoxInfo.btncolor = "#FFFFFF";
    }

    // IF BUTTON COLOR TEXT DOESN'T EXIST, SET IT TO BLACK
    if (!this.selectedBoxInfo.btntext) {
      this.selectedBoxInfo.btntext = "#000000";
    }

    // IF ICON COLOR DOESN'T EXIST, SET IT TO BLACK
    if (!this.selectedBoxInfo.iconColor) {
      this.selectedBoxInfo.iconColor = "#FFFFFF";
    }

    if (this.selectedBoxInfo.showIcon) {
      this.showSelection = "ICON";
    } else if (this.selectedBoxInfo.showIconImage) {
      this.showSelection = "IMAGE";
    } else if (this.selectedBoxInfo.showBgImage) {
      this.showSelection = "BGIMAGE";
    }
    
    if (this.selectedBoxInfo.pageName == "Costum-link") {
      this.mediaType = "website";
    } else if (this.selectedBoxInfo.pageName == "file") {
      this.mediaType = "pdf";
      this.selectedFileUrl = this.selectedBoxInfo.page;
    } else if (this.selectedBoxInfo.pageName == "mobilePhone") {
      this.mediaType = "phoneNumber";
      this.mobilePhoneNumber = this.selectedBoxInfo.page;
    } else if (this.selectedBoxInfo.pageName == "emailAddress") {
      this.mediaType = "email";
      this.emailAddress = this.selectedBoxInfo.page;
    } else {
      this.mediaType = "page";
      this.selectedPage = this.selectedBoxInfo.page;
    }
    this.selectedIcon = this.box.icon;

    // Edit pagesObject to fit GlobalInputDropdown values
    Object.values(this.pagesObject).forEach((page) => {
      let pageObject = {};
      pageObject.text = page.name;
      pageObject.value = page.path;

      this.pagesArray.push(pageObject);
    });

    // Last item of pagesArray is an overview object. We do not want this in the array
    this.pagesArray.pop();
  },
  computed: {
    provideLinkError() {
      if (this.mediaType === "pdf" && this.selectedFileUrl === "None") {
        return true;
      }
      // needs improvement when multi languages are enabled
      //  else if (
      //   (this.mediaType === "website" &&
      //     this.secondLanguage) ||
      //   (this.mediaType === "website" &&
      //     this.httpLink === "" &&
      //     !this.secondLanguage)
      // ) {
      //   return true;
      // } 
      else if (
        this.mediaType === "phoneNumber" &&
        this.mobilePhoneNumber === ""
      ) {
        return true;
      } else if (this.mediaType === "email" && this.emailAddress === "") {
        return true;
      } else if (this.mediaType === "page" && this.selectedPage === "None") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    handleShowIconModal() {
      this.showIconModal = this.showIconModal ? false : true;
    },
    selectedNewIcon(payload) {
      this.selectedIcon = payload;
    },
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.showTextColorPicker = false;
        this.close();
      }
    },
    charactersRemaining(string) {
      if (string) {
        return string.length;
      } else {
        return 0;
      }
    },
    close() {
      this.$emit("close");
      this.showTextColorPicker = false;
    },
    closeColorPicker() {
      this.showTextColorPicker = false;
    },
    showColorPicker(activeBox) {
      if (activeBox === "btntext" || activeBox === "btncolor") {
        this.changedPickerPosition = true;
      } else {
        this.changedPickerPosition = false;
      }
      this.showTextColorPicker = true;
      this.activeColorPicker = activeBox;
      this.colors[activeBox].hex = this.selectedBoxInfo[activeBox];
    },
    btnUpdate() {
      this.completeBoxArray[this.selectedBoxIndex] = {
        ...this.selectedBoxInfo,
        httpLinks: this.box.httpLinks ? this.box.httpLinks.filter(Boolean) : this.httpLinks
      };
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(this.completeBoxArray);
      this.close();
      this.$toastEvents.push({
        type: "positive",
        title: "Success",
        content: "The box has been updated",
        id: +new Date(),
      });
    },
    btnCancel() {
      this.close();
    },
    saveSelection(selection) {
      this.selectedPage = selection;
    },
    saveFileSelection(file) {
      this.selectedBoxInfo.page = file;
      this.selectedBoxInfo.pageName = "file";
    },
    onSelectedImage(imageUrl) {
      if(this.showSelection === 'BGIMAGE') {
        this.selectedBoxInfo.backgroundImage = imageUrl;
      } else {
        this.selectedBoxInfo.iconImage = imageUrl;
      }
    },
    toggleLanguage(indexClicked) {
      this.localLanguageTypesIndex = Number(indexClicked);
    },
  },
};
</script>

<style scoped>
.color-button-wrapper {
  background-color: var(--light);
  height: 42px;
  position: relative;
  border-radius: 0px 0px 8px 8px;
  border-top: solid 1px var(--grey-light);
}

.input-group .h2 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.icon-image-container {
  display: flex;
}

.icon-image-container__radio-container {
  flex-grow: 0;
  flex-shrink: 0;
}

.icon-image-container__radio-container button {
  margin-bottom: 16px;
  width: 180px;
}

.icon-image-container__icon,
.icon-image-container__image {
  width: 100%;
  height: 120px;
  display: flex;
  margin-left: 16px;
  border-radius: var(--border-radius);
}

.icon-image-container__icon {
  border: solid 1px var(--grey);
}

.icon-image-container__icon .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin: auto;
}

.icon-image-container__image {
  background-color: var(--grey-light);
}

.icon-image-container__image img {
  width: 100%;
  border-radius: var(--border-radius);
  object-fit: contain;
}

.input-group .input-switch {
  margin-bottom: 20px;
}

.color-input-wrapper {
  position: relative;
}

.color-indicator {
  width: 28px;
  height: 28px;
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  border-radius: var(--border-radius);
  border: 2px solid var(--grey);
}

.colorPickerWrapper {
  position: relative;
}

.colorOuterWrap {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
}

.vc-sketch {
  width: 282px;
  border-radius: 8px 8px 0px 0px;
  box-shadow: none;
}

.colorInnerWrap button {
  position: absolute;
  top: 8px;
  right: 14px;
  background-color: #48b9ba;
  color: #fff;
  cursor: pointer;
  width: 70px;
  height: 24px;
  border: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: 0.1s ease-in;
}
.colorInnerWrap button:hover {
  background-color: #49a39c;
}
.colorInnerWrap button.closeBtn {
  right: 94px;
  background-color: #894e99;
}

.horizontal-radio {
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
}

.horizontal-radio .input-radio:last-child {
  margin-bottom: 4px;
}
</style>
